var space = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
var borderWidths = [0, 1];
var borderStyles = ['none', 'solid'];
var zIndices = {
  modal: 1,
  tooltip: 2,
  taskbar: 2
};
export var generateShadows = function generateShadows(colors) {
  return {
    out: "inset 0.5px 0.5px 0px 0.5px ".concat(colors.borderLightest, ",\n          inset 0 0 0 1px ").concat(colors.borderDark, ",\n          1px 0px 0 0px ").concat(colors.borderDarkest, ",\n          0px 1px 0 0px ").concat(colors.borderDarkest, ",\n          1px 1px 0 0px ").concat(colors.borderDarkest),
    "in": "inset 0px 0px 0px 0px,\n        inset 1px 1px 0px 0px ".concat(colors.borderDark, ",\n        0.5px 0.5px 0px 0.5px ").concat(colors.borderLightest),
    input: "inset -1px -1px 0 0 ".concat(colors.material, ",\n            inset 1px 1px 0 0 ").concat(colors.borderDarkest, ",\n            0.5px 0.5px 0 0.5px ").concat(colors.borderLightest)
  };
};
var theme = {
  space: space,
  borderWidths: borderWidths,
  borderStyles: borderStyles,
  zIndices: zIndices
};
export default theme;